module.exports = __webpack_public_path__ + "static/media/app-qr-code.1919bed6.svg";